// extracted by mini-css-extract-plugin
module.exports = {"floatingLabelContainer":"FloatingLabel_floatingLabelContainer__hWHNk","floatingLabel":"FloatingLabel_floatingLabel__11x_K"};